module.exports = __webpack_public_path__ + "img/Flag_of_France (1).f64380d7.svg";